import { useNavigate, useParams } from 'react-router-dom';

import config from '../../../config/config';

import SettingsCompanyPage from './company';
import SettingsPersonPage from './person';

export default function SettingSelect() {
  const params = useParams();
  const navigate = useNavigate();
  const { USERS_TYPES } = config;

  if (!USERS_TYPES.includes(params.type || '')) {
    navigate('/');
  }

  return (
    <>
      {params.type !== 'company' ? <SettingsPersonPage /> : <SettingsCompanyPage />}
    </>
  );
}
